import { Container, Grid, CircularProgress, useTheme } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { PortalScreenHeader } from "../../../../components/PortalScreenHeader";
import { OrdersTable } from "./components/OrdersTable";
import PortalService from "../../../../services/supabase/PortalService";
import { OrderDetails } from "../../../../models/DB";

const Orders = () => {
    const theme = useTheme();
    const portalService = PortalService();
    const [isLoading, setIsLoading] = useState(false);
    const [allOrders, setAllOrders] = useState<OrderDetails[]>([]);

    // const orders = [
    //     {
    //         "id": "235ce2cc-ea03-4f38-a656-dfcde7aa9463",
    //         "reference": "b8078969-3b7b-4ac4-a65f-405e9f8486bf",
    //         "orderId": "B8078969",
    //         "created": "2024-10-29T22:39:29.834756+00:00",
    //         "status": 1,
    //         "shippingDetails": {
    //             "zip": "7441",
    //             "city": "Cape Town",
    //             "region": "Western Cape",
    //             "country": "South Africa",
    //             "addressLine1": "1 North Bank Lane,",
    //             "addressLine2": "Island Club Hotel,"
    //         },
    //         "contactDetails": {
    //             "email": "deniellalla@gmail.com",
    //             "lastName": "LALLA",
    //             "contactNo": "+27730481212",
    //             "firstName": "Deniel"
    //         },
    //         "order": [
    //             {
    //                 "product": {
    //                     "id": "82f95835-65ac-49e0-b884-159d373282f9",
    //                     "code": "4f46019b-9844-4ed1-b663-802b2d526eea",
    //                     "name": "Vodka - Hot, Lnferno",
    //                     "price": 388.62,
    //                     "images": {
    //                         "thumbnail": {
    //                             "url": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAAXNSR0IArs4c6QAAAHRJREFUGFcBaQCW/wEPNgX/mXSVAMs+gAAIb/0AVcR3AAE2QAH/u/pgABJT/QCVtEEACnhnAAEu7A7/V2YPAA7uIABIqXQAU2SyAAGFVsr/eQU3APho+gDhEUYA7be6AAGTrgr/ytOhAFyxbADF+nEAibPqAPAgKVsaBQ9sAAAAAElFTkSuQmCC"
    //                         }
    //                     },
    //                     "created": "2024-09-23T12:36:43.189155+00:00",
    //                     "inStock": true,
    //                     "updated": "2024-09-23T12:36:43.751138+00:00",
    //                     "category": "Tools",
    //                     "discount": "56",
    //                     "description": "venenatis turpis enim blandit mi in porttitor pede justo eu massa donec dapibus duis at velit eu est congue elementum in hac habitasse platea dictumst morbi vestibulum velit id pretium iaculis",
    //                     "stockOnHand": 641,
    //                     "variantType": "Size",
    //                     "variantOptions": [
    //                         "Small",
    //                         "Medium",
    //                         "Large",
    //                         "X-Large",
    //                         "XX-Large"
    //                     ],
    //                     "selectedVariant": null
    //                 },
    //                 "quantity": 1,
    //                 "selectedVariant": "Small"
    //             },
    //             {
    //                 "product": {
    //                     "id": "82f95835-65ac-49e0-b884-159d373282f9",
    //                     "code": "4f46019b-9844-4ed1-b663-802b2d526eea",
    //                     "name": "Vodka - Hot, Lnferno",
    //                     "price": 388.62,
    //                     "images": {
    //                         "thumbnail": {
    //                             "url": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAAXNSR0IArs4c6QAAAHRJREFUGFcBaQCW/wEPNgX/mXSVAMs+gAAIb/0AVcR3AAE2QAH/u/pgABJT/QCVtEEACnhnAAEu7A7/V2YPAA7uIABIqXQAU2SyAAGFVsr/eQU3APho+gDhEUYA7be6AAGTrgr/ytOhAFyxbADF+nEAibPqAPAgKVsaBQ9sAAAAAElFTkSuQmCC"
    //                         }
    //                     },
    //                     "created": "2024-09-23T12:36:43.189155+00:00",
    //                     "inStock": true,
    //                     "updated": "2024-09-23T12:36:43.751138+00:00",
    //                     "category": "Tools",
    //                     "discount": "56",
    //                     "description": "venenatis turpis enim blandit mi in porttitor pede justo eu massa donec dapibus duis at velit eu est congue elementum in hac habitasse platea dictumst morbi vestibulum velit id pretium iaculis",
    //                     "stockOnHand": 641,
    //                     "variantType": "Size",
    //                     "variantOptions": [
    //                         "Small",
    //                         "Medium",
    //                         "Large",
    //                         "X-Large",
    //                         "XX-Large"
    //                     ],
    //                     "selectedVariant": null
    //                 },
    //                 "quantity": 2,
    //                 "selectedVariant": "XX-Large"
    //             },
    //             {
    //                 "product": {
    //                     "id": "8594e30d-a98e-47d0-bd3b-826822d2df1e",
    //                     "code": "8577e4d0-590b-433d-9871-c0518dce4a15",
    //                     "name": "Tamarind Paste",
    //                     "price": 376.54,
    //                     "images": {
    //                         "thumbnail": {
    //                             "url": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAAXNSR0IArs4c6QAAAHRJREFUGFcBaQCW/wESpHT/FKgyAJt3YACYv7IA6k5PAAGu2m3/gV7AAB97igCE5EEAwvnrAAGgQe7/9oTRAAMVpwCLkd0AmYX7AAF52a3/EpekAHSbkwAkMFoA1Y2vAAGzXBf/Z/HgAOnoOgCUdvgA3l3HAIh6LyeIzoXeAAAAAElFTkSuQmCC"
    //                         }
    //                     },
    //                     "created": "2024-09-23T12:36:43.189155+00:00",
    //                     "inStock": true,
    //                     "updated": "2024-09-23T12:36:43.751138+00:00",
    //                     "category": "Toys",
    //                     "discount": "7",
    //                     "description": "porta volutpat erat quisque erat eros viverra eget congue eget semper rutrum nulla nunc purus phasellus in felis donec semper sapien a libero nam dui proin leo odio porttitor id consequat in consequat ut nulla sed accumsan felis ut at dolor quis odio consequat varius integer ac",
    //                     "stockOnHand": 889,
    //                     "variantType": "Color",
    //                     "variantOptions": [
    //                         "Red",
    //                         "Green",
    //                         "Blue",
    //                         "Yellow",
    //                         "Black",
    //                         "White"
    //                     ],
    //                     "selectedVariant": null
    //                 },
    //                 "quantity": 1,
    //                 "selectedVariant": "Blue"
    //             },
    //             {
    //                 "product": {
    //                     "id": "8594e30d-a98e-47d0-bd3b-826822d2df1e",
    //                     "code": "8577e4d0-590b-433d-9871-c0518dce4a15",
    //                     "name": "Tamarind Paste",
    //                     "price": 376.54,
    //                     "images": {
    //                         "thumbnail": {
    //                             "url": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAAXNSR0IArs4c6QAAAHRJREFUGFcBaQCW/wESpHT/FKgyAJt3YACYv7IA6k5PAAGu2m3/gV7AAB97igCE5EEAwvnrAAGgQe7/9oTRAAMVpwCLkd0AmYX7AAF52a3/EpekAHSbkwAkMFoA1Y2vAAGzXBf/Z/HgAOnoOgCUdvgA3l3HAIh6LyeIzoXeAAAAAElFTkSuQmCC"
    //                         }
    //                     },
    //                     "created": "2024-09-23T12:36:43.189155+00:00",
    //                     "inStock": true,
    //                     "updated": "2024-09-23T12:36:43.751138+00:00",
    //                     "category": "Toys",
    //                     "discount": "7",
    //                     "description": "porta volutpat erat quisque erat eros viverra eget congue eget semper rutrum nulla nunc purus phasellus in felis donec semper sapien a libero nam dui proin leo odio porttitor id consequat in consequat ut nulla sed accumsan felis ut at dolor quis odio consequat varius integer ac",
    //                     "stockOnHand": 889,
    //                     "variantType": "Color",
    //                     "variantOptions": [
    //                         "Red",
    //                         "Green",
    //                         "Blue",
    //                         "Yellow",
    //                         "Black",
    //                         "White"
    //                     ],
    //                     "selectedVariant": null
    //                 },
    //                 "quantity": 2,
    //                 "selectedVariant": "Red"
    //             },
    //             {
    //                 "product": {
    //                     "id": "8594e30d-a98e-47d0-bd3b-826822d2df1e",
    //                     "code": "8577e4d0-590b-433d-9871-c0518dce4a15",
    //                     "name": "Tamarind Paste",
    //                     "price": 376.54,
    //                     "images": {
    //                         "thumbnail": {
    //                             "url": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAAXNSR0IArs4c6QAAAHRJREFUGFcBaQCW/wESpHT/FKgyAJt3YACYv7IA6k5PAAGu2m3/gV7AAB97igCE5EEAwvnrAAGgQe7/9oTRAAMVpwCLkd0AmYX7AAF52a3/EpekAHSbkwAkMFoA1Y2vAAGzXBf/Z/HgAOnoOgCUdvgA3l3HAIh6LyeIzoXeAAAAAElFTkSuQmCC"
    //                         }
    //                     },
    //                     "created": "2024-09-23T12:36:43.189155+00:00",
    //                     "inStock": true,
    //                     "updated": "2024-09-23T12:36:43.751138+00:00",
    //                     "category": "Toys",
    //                     "discount": "7",
    //                     "description": "porta volutpat erat quisque erat eros viverra eget congue eget semper rutrum nulla nunc purus phasellus in felis donec semper sapien a libero nam dui proin leo odio porttitor id consequat in consequat ut nulla sed accumsan felis ut at dolor quis odio consequat varius integer ac",
    //                     "stockOnHand": 889,
    //                     "variantType": "Color",
    //                     "variantOptions": [
    //                         "Red",
    //                         "Green",
    //                         "Blue",
    //                         "Yellow",
    //                         "Black",
    //                         "White"
    //                     ],
    //                     "selectedVariant": null
    //                 },
    //                 "quantity": 5,
    //                 "selectedVariant": "Green"
    //             },
    //             {
    //                 "product": {
    //                     "id": "8a054c6f-cabe-496f-ab2d-dd427d545ce4",
    //                     "code": "04593c96-4745-4e01-9cec-184e411e2838",
    //                     "name": "Lamb - Ground",
    //                     "price": 275.15,
    //                     "images": {
    //                         "thumbnail": {
    //                             "url": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAAXNSR0IArs4c6QAAAHRJREFUGFcBaQCW/wESpHT/FKgyAJt3YACYv7IA6k5PAAGu2m3/gV7AAB97igCE5EEAwvnrAAGgQe7/9oTRAAMVpwCLkd0AmYX7AAF52a3/EpekAHSbkwAkMFoA1Y2vAAGzXBf/Z/HgAOnoOgCUdvgA3l3HAIh6LyeIzoXeAAAAAElFTkSuQmCC"
    //                         }
    //                     },
    //                     "created": "2024-09-23T12:36:43.189155+00:00",
    //                     "inStock": true,
    //                     "updated": "2024-09-23T12:36:43.751138+00:00",
    //                     "category": "Electronics",
    //                     "discount": "74",
    //                     "description": "felis ut at dolor quis odio consequat varius integer ac leo pellentesque ultrices mattis odio donec vitae nisi nam ultrices libero non mattis pulvinar",
    //                     "stockOnHand": 661,
    //                     "variantType": "Size",
    //                     "variantOptions": [
    //                         "Small",
    //                         "Medium",
    //                         "Large",
    //                         "X-Large",
    //                         "XX-Large"
    //                     ],
    //                     "selectedVariant": null
    //                 },
    //                 "quantity": 4,
    //                 "selectedVariant": "Medium"
    //             }
    //         ],
    //         "email": "deniellalla@gmail.com",
    //         "deliveryType": "standard",
    //         "deliveryFee": 100,
    //         "suburb": "",
    //         "baseCost": 5278.78,
    //         "vat": 791.817,
    //         "totalCost": 6170.597,
    //         "updated": "2024-10-29T22:39:29.834756+00:00"
    //     }
    // ]

    useEffect(() => {
        const fetchOrders = async () => {
            setIsLoading(true);
            const orders = await portalService.getAllOrders();
            setAllOrders(orders ?? []);
            setIsLoading(false);
        };
        fetchOrders();
    }, []);

    return (
        <Container
            component="main"
            maxWidth="xl"
            sx={{
                height: "100%",
                paddingX: { xs: 0, md: 2 },
            }}>
            {
                isLoading ?
                    <Grid container justifyContent="center" mt={20}>
                        <Grid item>
                            <CircularProgress
                                size={40}
                                sx={{ color: theme.palette.primary.main }}
                            />
                        </Grid>
                    </Grid>
                    :
                    <>
                        <PortalScreenHeader
                            title="Orders"
                            subtitle="View and manage customer orders"
                            icon={<ShoppingCart />}
                        />
                        <OrdersTable
                            orders={allOrders}
                        />
                    </>
            }
        </Container>
    );
};

export default Orders;
